import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { AssistantActionCardComponent } from './action-card/action-card.component';
import { AssistantTextChangeComponent } from './text-change/text-change.component';
import { AssistantMarkdownPipe, AssistantSegmentsPipe } from './assistant-markdown.pipe';
import { AssistantPanelComponent } from './assistant-panel/assistant-panel.component';
import { AssistantLauncherComponent } from './launcher/assistant-launcher.component';
import { AssistantManagedBannerComponent } from './managed-banner/assistant-managed-banner.component';
import { AssistantTableComponent, AssistantTableDialogComponent } from './table/assistant-table.component';

/**
 * Assistente AI context-aware: pannello + pulsante flottante, entrambi montati nel layout.
 * Servizi providedIn root: lo stato sopravvive alla navigazione.
 */
@NgModule({
	declarations: [
		AssistantPanelComponent,
		AssistantActionCardComponent,
		AssistantTextChangeComponent,
		AssistantLauncherComponent,
		AssistantManagedBannerComponent,
		AssistantMarkdownPipe,
		AssistantSegmentsPipe,
		AssistantTableComponent,
		AssistantTableDialogComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatDialogModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		TranslateModule.forChild()
	],
	exports: [
		AssistantPanelComponent,
		AssistantLauncherComponent,
		AssistantManagedBannerComponent
	]
})
export class AssistantModule{}
